import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import usePartnerAuth from 'hooks/usePartnerAuth';
import Loader from 'components/Loader';

// ==============================|| ADMIN GUARD — require the admin role ||============================== //
//
// Keeps members out of administrator-only pages. Presentation only: the APIs
// those pages call re-check the role server-side, so bypassing this guard yields
// a 403, not access. Sits inside AuthGuard, so the user is already signed in.

export default function AdminGuard({ children }) {
  const { isAdmin, isInitializing } = usePartnerAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitializing && !isAdmin) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAdmin, isInitializing, navigate]);

  if (isInitializing || !isAdmin) return <Loader />;

  return children;
}

AdminGuard.propTypes = { children: PropTypes.node };
